import { FC } from "react";

interface DefaultHoverPopupProps {
  address: string;
}

const DefaultHoverPopup: FC<DefaultHoverPopupProps> = ({ address }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        padding: 12,
        borderRadius: 8,
        width: 340,
        boxShadow:
          "rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px",
        textTransform: "uppercase",
        fontWeight: "bolder",
        fontSize: 14,
      }}
    >
      {address}
    </div>
  );
};

export default DefaultHoverPopup; 